import React, { Component } from 'react'
import Card from "react-bootstrap/Card";
import CardDeck from "react-bootstrap/CardDeck";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MicsoftLogo from '../../assets/img/skills/microsoft-logo-svg-vector.svg'

// skills
import { skills, aiCloudDataSkills } from "./skills-data";
import "./skills-style.css";

 class TechnicalSkills extends Component {

  // componentDidMount (){

  //   if (typeof window !== "undefined") {
  //     if (window.fbq != null) { 
         
  //       window.fbq('track', 'PageView')
  //     }
  //   }

  // }
    render() {
        return (
            <div className="pt-3 pb-3" id="skills">
            <h1 className="text-center font-details-b pb-4">TECHNOLOGY PROFICIENCIES</h1>
            <CardDeck>
              <Row className="d-flex justify-content-around">
                {/* Frontend */}
                <Col md={4}>
                  <Card className="focus mt-2 mb-2">
                    <Card.Body>
                      {/* Frontend */}
                      <Card.Title className="text-center  card-title">Frontend</Card.Title>
                      <hr />
                      <Card.Text className="card-text d-flex justify-content-start flex-column">
                        {skills.frontend.map((skill, index) => (
                          <span className="p-2" key={index}>
                            <a className="text-dark text-decoration-none" href={skill.link} target="_blank" rel="noopener noreferrer">
                              <Image src={skill.imgSrc} alt={skill.imgAltText} rounded className="image-style m-1"></Image> {skill.skillName}
                            </a>
                          </span>
                        ))}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                            {/* Version Control */}
      
                            <Card className="focus mt-2 mb-2">
                    <Card.Body>
                      <Card.Title className="text-center  card-title">Version Control</Card.Title>
                      <hr />
                      <Card.Text className="card-text d-flex justify-content-start flex-column">
                      {skills.versionControl.map((skill, index) => (
                          <span className="p-2" key={index}>
                            <a className="text-dark text-decoration-none" href={skill.link} target="_blank" rel="noopener noreferrer">
                              <Image src={skill.imgSrc} alt={skill.imgAltText} rounded className="image-style m-1"></Image> {skill.skillName}
                            </a>
                          </span>
                        ))}
                        {/* <span className="p-2">
                          <a className="text-dark text-decoration-none" href={skills.versionControl[0].link} target="_blank" rel="noopener noreferrer">
                            <Image src={skills.versionControl[0].imgSrc} alt={skills.versionControl[0].imgAltText} rounded className="image-style m-1"></Image> {skills.versionControl[0].skillName}
                          </a>
                        </span> */}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
               
                {/* Backend */}
                <Col md={4}>
                  <Card className="focus mt-2 mb-2">
                    <Card.Body>
                      <Card.Title className="text-center  card-title"><Image src={MicsoftLogo} alt="Logo" rounded className="image-style m-1"></Image> Technologies</Card.Title>
                      <hr />
                      <Card.Text className="card-text d-flex justify-content-start flex-column">
                        {skills.backend.map((skill, index) => (
                          <span className="p-2" key={index}>
                            <a className="text-dark text-decoration-none" href={skill.link} target="_blank" rel="noopener noreferrer">
                              <Image src={skill.imgSrc} alt={skill.imgAltText} rounded className="image-style m-1"></Image> {skill.skillName}
                            </a>
                          </span>
                        ))}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                     {/* FrameWorks */}
               
                     <Card className="focus mt-2 mb-2">
                    <Card.Body>
                      {/* FrameWorks */}
                      <Card.Title className="text-center  card-title">FrameWorks</Card.Title>
                      <hr />
                      <Card.Text className="card-text d-flex justify-content-start flex-column">
                        {skills.framework.map((skill, index) => (
                          <span className="p-2" key={index}>
                            <a className="text-dark text-decoration-none" href={skill.link} target="_blank" rel="noopener noreferrer">
                              <Image src={skill.imgSrc} alt={skill.imgAltText} rounded className="image-style m-1"></Image> {skill.skillName}
                            </a>
                          </span>
                        ))}
                      </Card.Text>
                    </Card.Body>
                  </Card>
      
                  
                </Col>
      
                {/* Programming Languages */}
                <Col md={4}>
                  <Card className="focus mt-2 mb-2">
                    <Card.Body>
                      <Card.Title className="text-center  card-title">Programming Languages</Card.Title>
                      <hr />
                      <Card.Text className="card-text d-flex justify-content-start flex-column">
                        {skills.programmingLanguages.map((skill, index) => (
                          <span className="p-2" key={index}>
                            <a className="text-dark text-decoration-none" href={skill.link} target="_blank" rel="noopener noreferrer">
                              <Image src={skill.imgSrc} alt={skill.imgAltText} rounded className="image-style m-1"></Image> {skill.skillName}
                            </a>
                          </span>
                        ))}
                      </Card.Text>
                    </Card.Body>
                  </Card>
      
                  {/* Database */}
      
                  <Card className="focus mt-2 mb-2">
                    <Card.Body>
                      <Card.Title className="text-center  card-title">Database</Card.Title>
                      <hr />
                      <Card.Text className="card-text d-flex justify-content-start flex-column">
                        {skills.databases.map((skill, index) => (
                          <span className="p-2" key={index}>
                            <a className="text-dark text-decoration-none" href={skill.link} target="_blank" rel="noopener noreferrer">
                              <Image src={skill.imgSrc} alt={skill.imgAltText} rounded className="image-style m-1"></Image> {skill.skillName}
                            </a>
                          </span>
                        ))}
                      </Card.Text>
                    </Card.Body>
                  </Card>
        
                
               {/* Hosting Platforms */}
               <Card className="focus mt-2 mb-2 ">
                    <Card.Body>
                      <Card.Title className="text-center  card-title">Hosting Platforms</Card.Title>
                      <hr />
                      <Card.Text className="card-text d-flex justify-content-start flex-column">
                        {skills.hostingPlatforms.map((skill, index) => (
                          <span className="p-2" key={index}>
                            <a className="text-dark text-decoration-none" href={skill.link} target="_blank" rel="noopener noreferrer">
                              <Image src={skill.imgSrc} alt={skill.imgAltText} rounded className="image-style m-1"></Image> {skill.skillName}
                            </a>
                          </span>
                        ))}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

              </Row>
            </CardDeck>
            <Row className="d-flex justify-content-center mt-3">
              <Col md={10} lg={10}>
                <Card className="focus mt-2 mb-2">
                  <Card.Body>
                    <Card.Title className="text-center card-title">AI, cloud &amp; data engineering</Card.Title>
                    <hr />
                    <Card.Text as="ul" className="text-left pl-3 mb-0">
                      {aiCloudDataSkills.map((line, index) => (
                        <li key={index} className="mb-2">{line}</li>
                      ))}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        )
    }
}

export default TechnicalSkills
